import { EnvelopeIcon, PhoneIcon } from "@heroicons/react/24/outline"
import useTranslations from "../hooks/useTranslations"
import ImageTeamMember from "./ImageTeamMember"

const TeamMember = ({
  name,
  position,
  positionNote,
  image,
  description,
  linkHref,
  linkText,
  phone,
  email,
}) => {
  const { [description]: desc } = useTranslations()

  return (
    <>
      <div className="mb-6 max-w-fit">
        <ImageTeamMember filename={image} alt={name} />
      </div>
      <div>
        <h3 className="m-0 mt-4 text-lg font-semibold leading-7 tracking-tight text-gray-900">
          {name}
        </h3>
        <p className="m-0 text-base leading-6 text-gray-600">
          {position}
          {positionNote ? (
            <span className="italic text-gray-500"> {positionNote}</span>
          ) : null}
          {linkHref && (
            <a href={linkHref} style={{ textDecoration: "underline" }}>
              {linkText}
            </a>
          )}
        </p>
        <div className="flex justify-center gap-2">
          {phone ? (
            <a href={`tel:${phone}`} className="flex">
              <p className="mb-0 text-sm leading-6 text-zinc-500 hover:text-kkm-green">
                {phone}
              </p>
            </a>
          ) : null}
          {email ? (
            <a href={`mailto:${email}`} className="flex">
              <dd className="flex items-center text-zinc-400 hover:text-kkm-green">
                <EnvelopeIcon className="h-5 w-5 shrink-0" aria-hidden="true" />
              </dd>
            </a>
          ) : null}
        </div>
        <div className="">{desc}</div>
      </div>
    </>
  )
}

export default TeamMember
